<template>
    <div>
        <my-search 
        v-model="pgData" 
        @search="searchHandler"
        title-placeholder="项目/购标单位名称"
        >

            <el-form-item slot="time">
                <el-radio-group v-model="pgData.issh" @change="searchHandler">
                    <el-radio-button label="0">未开发票</el-radio-button>
                    <el-radio-button label="1">已开发票</el-radio-button>
                </el-radio-group>
            </el-form-item>
            
            <template slot="title">
                <el-form-item>
                    <el-input 
                        v-model="pgData.txtKey1Val" 
                        placeholder="购标单位名称"
                        clearable
                    ></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input 
                        v-model="pgData.txtKey" 
                        placeholder="项目名称"
                        clearable
                    ></el-input>
                </el-form-item>

                <el-form-item>
                    <el-date-picker
                    v-model="bgtime"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="购标开始日期"
                    end-placeholder="购标结束日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <my-select
                    placeholder="请选择付款方式"
                    v-model="pgData.fkfs"
                    :data="fkfsList"
                    :props="{label:'name',value:'id'}"
                    ></my-select>
                </el-form-item>

                <el-form-item>
                    <my-select
                    placeholder="请选择发票获取方式"
                    v-model="pgData.fphqVal"
                    :data="fphqList"
                    :props="{label:'name',value:'id'}"
                    ></my-select>
                </el-form-item>
            </template>
            <el-form-item>
                
            </el-form-item>
            
            <template slot="btn">
                <el-button 
                type="warning" 
                icon="el-icon-setting" 
                @click="setInvoiceType"
                >
                    设置增值税普通发票类别
                </el-button>

                <el-button 
                v-if="dwcode === 'E0000001881'"
                type="warning" 
                icon="el-icon-view" 
                @click="goto('./elec/list')"
                >
                    查看电子发票使用情况
                </el-button>
            </template>
        </my-search>

        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="购标信息" prop="orderscode" sortable min-width="220">
                <template slot-scope="scope">
                    <div class="table-info-row">
                        <b>{{scope.row.tbdwname}}</b>
                    </div>
                    <div class="table-info-row">
                        {{scope.row.orderscode}}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="购标日期" prop="gbdate" sortable min-width="150"></el-table-column>

            <el-table-column label="项目信息" prop="zbprocode" sortable min-width="240">
                <template slot-scope="scope">
                    <div class="table-info-row">
                        <b>{{scope.row.zbproname}}</b>
                    </div>
                    <div class="table-info-row">
                        {{scope.row.zbprocode}}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="开标时间" prop="by1" sortable min-width="150"></el-table-column>
            <el-table-column label="公告截止时间" prop="by2" sortable min-width="150"></el-table-column>
            
            <el-table-column label="发票获取方式" prop="by3" min-width="120">
                <template v-slot="scope">
                    <template v-if="scope.row.fptype=='1'">
                        电子发票
                    </template>
                    <template v-else>
                        {{scope.row.by3 || '电子发票'}}

                        {{scope.row.mailgs || ''}}
                        {{scope.row.mailno || ''}}
                    </template>
                    
                </template>
            </el-table-column>

            <el-table-column label="付款方式" prop="fkfs" sortable min-width="100">
                <template slot-scope="scope">
                    <state-list 
                        :key="scope.row.orderscode"
                        :row="scope.row" 
                        :config="FKFS"
                    ></state-list>
                </template>
            </el-table-column>
            
            
            <el-table-column label="操作" min-width="180" fixed="right">
                <template slot-scope="scope">
                    <btn-list
                        :row="scope.row" 
                        :config="BTN_CONF"
                        @reload="reloadHandler"
                    ></btn-list>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('mngUrl')}/manage/finance/auditorder/get_fplist.json`">
        </my-pagination>

        <my-dialog 
        v-model="dialogVisible"
        title="设置增值税普通发票类别"
        width="500px"
        >
            <form-invoice-type
                v-if="dialogVisible"
                @cancle="dialogClose"
            ></form-invoice-type>
        </my-dialog>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

import FKFS from './config/fkfs'
import BTN_CONF from './config/btns-list'

import FormInvoiceType from './sub-pages/form-invoice-type'

export default {
    mixins: [ LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN],
    components: { FormInvoiceType },
    data() {
        return {
            pgData: {
                sortname: 'fpbj,wjdjjztime',
                sortorder: 'asc',
                issh: '0',
                txtKey: '',
                txtkeyVal:'',
                txtKey1: '',
                txtKey1Val: '',
                gbstarttime:'',
                gbendtime:'',
                fphq:'',
                fphqVal:'',
                fkfs:'',
            },

            FKFS,
            BTN_CONF,

            dwcode: '',
            bgtime:'',

            fkfsList:[
                {name:'支付宝',id:'1'},
                {name:'线下支付',id:'9'},
                {name:'聚合支付',id:'3'},
                {name:'银联',id:'4'},
            ],
            fphqList:[
                {name:'电子发票',id:'电子发票'},
                {name:'邮寄',id:'邮寄'},
                {name:'自取',id:'自取'},
                {name:'开标现场自取',id:'开标现场自取'},
            ],

            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '今年至今',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date(new Date().getFullYear(), 0);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近六个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setMonth(start.getMonth() - 6);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },
    watch: {
        'pgData.txtkeyVal':function(o,n){
            this.pgData.txtKey =escape(o)
        },
        'pgData.txtKey1Val':function(o,n){
            this.pgData.txtKey1 =escape(o)
        },
        bgtime:function(newVal,n){
            if(newVal){
                this.pgData.gbstarttime = newVal[0]
                this.pgData.gbendtime = newVal[1]
            }
            
        },
        'pgData.fphqVal':function(o,n){
            this.pgData.fphq =escape(o)
        },

    },
    computed: {
        
    },
    methods: {
        setInvoiceType() {
            this.dialogShow();
        }
    },
    created() {
        this.jspInit(`${this.getGetters('mngUrl')}/manage/finance/auditorder/fplist.json`, {
            
        }, data => {
            this.jspDataInit(data, [
                'dwcode',
            ]);
        });
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
    .table-info-row + .table-info-row{margin-top:.5em;}
</style>
